import { ButtonIcon, Table } from '@statsbomb/kitbag-components';
import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import { REACT_APP_AUTH_ROLE_OPERATOR } from '../../AuthProvider';
import {
  getAlignmentIssueLabel,
  getAlignmentLastUpdated,
  getAlignmentStatusLabel,
  getButtonTitle,
  getMatchDateAndTime,
  getMatchName,
} from '../../utils/alignment-data';
import Secured from '../Secured';
import { EMPTY_CELL_VALUE } from '../../constants/tableRows';

export function MisalignedEventsTableRows({ misalignedEvents, handleEdit }) {
  const intl = useIntl();

  return misalignedEvents?.map(({ videoReference, videoInfo }) => (
    <Table.Row
      key={JSON.stringify({
        videoReference,
      })}
    >
      <Table.DataCell>{getMatchName(videoInfo, intl)}</Table.DataCell>
      <Table.DataCell>
        {videoReference?.matchId || EMPTY_CELL_VALUE}
      </Table.DataCell>
      <Table.DataCell>
        {videoReference?.period || EMPTY_CELL_VALUE}
      </Table.DataCell>
      <Table.DataCell>
        {videoInfo?.competition || EMPTY_CELL_VALUE}
      </Table.DataCell>
      <Table.DataCell>
        {videoInfo?.countryName || EMPTY_CELL_VALUE}
      </Table.DataCell>
      <Table.DataCell>{getMatchDateAndTime(videoInfo, intl)}</Table.DataCell>
      <Table.DataCell>
        {videoReference?.version || EMPTY_CELL_VALUE}
      </Table.DataCell>
      <Table.DataCell>
        {getAlignmentIssueLabel(videoInfo?.alignmentIssue, intl)}
      </Table.DataCell>
      <Table.DataCell>
        {getAlignmentStatusLabel(videoInfo?.alignmentStatus, intl)}
      </Table.DataCell>
      <Table.DataCell>
        <Secured allowed={REACT_APP_AUTH_ROLE_OPERATOR}>
          <ButtonIcon
            icon="Edit"
            title={getButtonTitle(intl)}
            onClick={() => handleEdit(videoReference)}
            size="small"
            variant="secondary"
          />
        </Secured>
      </Table.DataCell>
      <Table.DataCell>
        {getAlignmentLastUpdated(videoInfo, intl) || EMPTY_CELL_VALUE}
      </Table.DataCell>
    </Table.Row>
  ));
}

MisalignedEventsTableRows.propTypes = {
  handleEdit: PropTypes.func.isRequired,
};

export default { MisalignedEventsTableRows };
